import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOvEntry } from "../models/overage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create overage entry and return same object
 */

export const UpdateOverageEntryAPI = async (params: IOvEntry, osdNumber?: number | string) => {
  try {
    // Get static headers from map (do not use || {})
    const staticHeaders = getTrackingHeadersMap(ApiType.OVERAGE_UPDATE);
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Type": params?.type,
      "OSD-Exception-Number": osdNumber?.toString(),
      "OSD-Reporting-Terminal": params.reporting,
      "OSD-Origin-Terminal": params.origin,
      "OSD-Destination-Terminal": params.destination,
    };
    const response = await axios.put(`${getUrl(ApiType.OVERAGE_UPDATE)}/${osdNumber}`, params, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.updateOverageEntry, { badRequestOrder: "errorsFirst" });
  }
};
